import
{
    FC
} from "react";

import
{
    PriceList,
    PriceListItem,
    TextMessagePrice
} from "@ews/react-data";

import { useL10n } from "@ews/react-localization-context";
import { IonItem } from "@ionic/react";
import
{
    useModifyPriceList,
    usePriceList
} from "../ReactData/misc";
import SettingsCol from "../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsNumberInput from "../Settings/SettingsComponents/SettingsNumberInput/SettingsNumberInput";
import SettingsTextInput from "../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import SettingsGrid from "../Settings/SettingsGrid/SettingsGrid";
import { Locale } from "../../setup/locale";


export type PriceListDetailsProps = {
    priceListId: string;
};

const PriceListDetails: FC<PriceListDetailsProps> = ({
    priceListId
}) =>
{
    const priceList = usePriceList(priceListId);
    const modifyPriceList = useModifyPriceList();
    const { translate: t } = useL10n();

    //const licenses = ["COM_FACPMANAGEMENT_FACP_ELS_DETAILS", "COM_FACPMANAGEMENT_FACP_ELS_USEPUSH", "COM_FACPMANAGEMENT_FACP_ELS_PLANANSICHT"];
    const licenses = {
        licenseDetailView: "COM_FACPMANAGEMENT_FACP_ELS_DETAILS",
        licenseOperateAndNotification: "COM_FACPMANAGEMENT_FACP_ELS_USEPUSH",
        licensePlanView: "COM_FACPMANAGEMENT_FACP_ELS_PLANANSICHT"
    };

    const { licenseTextMessages = {} as TextMessagePrice } = priceList;

    const updatePriceList = (data: PriceList) =>
    {
        modifyPriceList(priceListId, data);
    };

    if (!priceList) return <></>;

    return <>
        <SettingsGrid >
            <SettingsCol xl="3">
                <SettingsTextInput
                    text={'COM_FACPMANAGEMENT_FACP_MANAGER_PRICES'}
                    textAlign="right"
                    value={priceList.priceList}
                    onChange={(name) =>
                    {
                        updatePriceList({ priceList: name } as PriceList);
                    }}
                />
                {/* <SettingsCheckbox
                    label={true}
                    text={'COM_CONTACT_CATEGORIES_VIEW_DEFAULT_OPTION'}
                    checked={priceList.default || false}
                    onChange={(value) =>
                    {
                        updatePriceList({ "default": value } as PriceList);
                    }}
                /> */}

            </SettingsCol>
        </SettingsGrid>

        <SettingsGrid >
            <SettingsCol xl="12" lg="12" md="12" sm="12">
                <IonItem>
                    <h1>{t("COM_FACPMANAGEMENT_WEBSHOP_LICENCES_OVERVIEW")}</h1>
                </IonItem>

            </SettingsCol>
            {Object.keys(licenses).map(license =>
            {
                const data = (priceList[license as keyof PriceList] as PriceListItem) || {};
                const { priceScale = [0, 0, 0] } = data;

                const updatePriceListItem = (data: PriceListItem) =>
                {
                    (priceList[license as keyof PriceList] as PriceListItem) = data;
                    updatePriceList({ ...priceList } as PriceList);
                };

                const setPrice = (index: number, price: number) =>
                {
                    priceScale[index] = price;
                    data.priceScale = priceScale;
                    updatePriceListItem(data);
                };


                return <SettingsCol xl="3" key={license}>
                    <IonItem>
                        <b>{t(licenses[license as keyof typeof licenses])}</b>
                    </IonItem>

                    <SettingsTextInput
                        text={'COM_VIRTUEMART_CART_SKU'}
                        textAlign="right"
                        value={data.productCode}
                        onChange={(value =>
                        {
                            data.productCode = value;
                            updatePriceListItem(data);
                        })}
                    />
                    <SettingsNumberInput
                        text={'COM_FACPMANAGEMENT_PRICES_BASE'}

                        step="0.01"
                        value={data.priceBase}
                        onChange={(value =>
                        {
                            data.priceBase = value;
                            updatePriceListItem(data);
                        })}
                    />
                    <SettingsNumberInput
                        text={'[REACT_DATA_POINTS]'}
                        step="0.01"
                        value={priceScale[0]}
                        onChange={(value) => setPrice(0, value)}

                    />
                    <SettingsNumberInput
                        text={t("[REACT_FROM_DATA_POINTS]", { dataPoints: "200." })}
                        step="0.01"
                        value={priceScale[1]}
                        onChange={(value) => setPrice(1, value)}
                    />
                    <SettingsNumberInput
                        text={t("[REACT_FROM_DATA_POINTS]", { dataPoints: "500." })}
                        step="0.01"
                        value={priceScale[2]}
                        onChange={(value) => setPrice(2, value)}
                    />
                </SettingsCol>;
            })}

            <SettingsCol xl="3">
                <IonItem>
                    <b>{t('[REACT_TEXT_MESSAGE]')}</b>
                </IonItem>

                <SettingsTextInput
                    text={'COM_VIRTUEMART_CART_SKU'}
                    textAlign="right"
                    value={licenseTextMessages.productCode}
                    onChange={(value =>
                    {
                        licenseTextMessages.productCode = value;
                        updatePriceList({ ...priceList, licenseTextMessages } as PriceList);
                    })}
                />
                <SettingsNumberInput
                    text={'COM_FACPMANAGEMENT_LOGS_SMS_PRICE, [REACT_RECEIVER]' as Locale}
                    value={licenseTextMessages.pricePerRecipient}
                    step="0.01"
                    onChange={(value) =>
                    {
                        licenseTextMessages.pricePerRecipient = value;
                        updatePriceList({ ...priceList, licenseTextMessages } as PriceList);
                    }}
                />
            </SettingsCol>
        </SettingsGrid>
    </>;
};

export default PriceListDetails;